import React from 'react';
import { useTranslation } from 'react-i18next';
import PageContent from 'components/Generic/PageContent';
import GlobalReports from './GlobalReports';

const GlobalReportsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageContent title={t('reports.global.title')}>
      <GlobalReports />
    </PageContent>
  );
};
export default GlobalReportsPage;
